module.exports = __webpack_public_path__ + "img/code_bg.7ebabf67.png";